import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
    <footer className="footer">
        <p>
            <Link to="/our-offer" className="nav-link">Our offer</Link>  {/* Link za Contact stranicu */}
            <Link to="/contact" className="nav-link">Contact</Link>  {/* Link za Contact stranicu */}
            <Link to="/TermsOfUse" className="nav-link">Terms of use</Link>  {/* Link za Contact stranicu */}
        </p>
        <div className="social-icons">
            <a href="#"><img src="/images/facebook.svg" alt="Facebook" /></a>
            <a href="#"><img src="/images/instagram.svg" alt="Instagram" /></a>
            <a href="#"><img src="/images/youtube.svg" alt="YouTube" /></a>
            <a href="#"><img src="/images/tiktok.svg" alt="TikTok" /></a>
        </div>
        <p>Copyright © 2024 TooRistico. Made in Serbia by IvkoSOFT</p>
    </footer>
);

export default Footer;
